import React from 'react'

function UnAuthorizeAccess() {
  return (
    <div className='w-100 text-center'>
      <h1 className='w-100 text-center'> Unauthorize Access</h1>
    </div>
  )
}

export default UnAuthorizeAccess
